import i18n from '../i18n';

const i18NNameList = [
  'ANDAMAN_NICOBAR_ISL',
  'ANDHRA_PRADESH',
  'ARUNACHAL_PRADESH',
  'ASSAM',
  'BIHAR',
  'CHANDIGARH',
  'CHHATTISGARH',
  'DADRA_HAVELI',
  'DELHI',
  'GOA',
  'GUJARAT',
  'HARYANA',
  'HIMACHAL_PRADESH',
  'JAMMU_KASHMIR',
  'JHARKHAND',
  'KARNATAKA',
  'KERALA',
  'LADAKH',
  'LAKSHADWEEP',
  'MADHYA_PRADESH',
  'MAHARASHTRA',
  'MANIPUR',
  'MEGHALAYA',
  'MIZORAM',
  'NAGALAND',
  'ODISHA',
  'PUDUCHERRY',
  'PUNJAB',
  'RAJASTHAN',
  'SIKKIM',
  'TAMILNADU',
  'TELANGANA',
  'TRIPURA',
  'UTTAR_PRADESH',
  'UTTARAKHAND',
  'WEST_BENGAL',
];
export const getTranslatedStateNameList = () => {
  return i18NNameList.map((stateI18N) => i18n.t(stateI18N));
};

export const stateName = [
  'ANDAMAN AND NICOBAR ISLAND',
  'ANDHRA PRADESH',
  'ARUNACHAL PRADESH',
  'ASSAM',
  'BIHAR',
  'CHANDIGARH',
  'CHHATTISGARH',
  'DADRA AND NAGAR HAVELI AND DAMAN AND DIU',
  'DELHI',
  'GOA',
  'GUJARAT',
  'HARYANA',
  'HIMACHAL PRADESH',
  'JAMMU KASHMIR',
  'JHARKHAND',
  'KARNATAKA',
  'KERALA',
  'LADAKH',
  'LAKSHADWEEP',
  'MADHYA PRADESH',
  'MAHARASHTRA',
  'MANIPUR',
  'MEGHALAYA',
  'MIZORAM',
  'NAGALAND',
  'ODISHA',
  'PUDUCHERRY',
  'PUNJAB',
  'RAJASTHAN',
  'SIKKIM',
  'TAMILNADU',
  'TELANGANA',
  'TRIPURA',
  'UTTAR PRADESH',
  'UTTARAKHAND',
  'WEST BENGAL',
];
export const stateI18NNameVsStateCode = {
  ANDAMAN_NICOBAR_ISL: 'AN',
  ANDHRA_PRADESH: 'AP',
  ARUNACHAL_PRADESH: 'AR',
  ASSAM: 'AS',
  BIHAR: 'BR',
  CHANDIGARH: 'CH',
  CHHATTISGARH: 'CT',
  DADRA_HAVELI: 'DH',
  DELHI: 'DL',
  GOA: 'GA',
  GUJARAT: 'GJ',
  HARYANA: 'HR',
  HIMACHAL_PRADESH: 'HP',
  JAMMU_KASHMIR: 'JK',
  JHARKHAND: 'JH',
  KARNATAKA: 'KA',
  KERALA: 'KL',
  LADAKH: 'LA',
  LAKSHADWEEP: 'LD',
  MADHYA_PRADESH: 'MP',
  MAHARASHTRA: 'MH',
  MANIPUR: 'MN',
  MEGHALAYA: 'ML',
  MIZORAM: 'MZ',
  NAGALAND: 'NL',
  ODISHA: 'OR',
  PUDUCHERRY: 'PY',
  PUNJAB: 'PB',
  RAJASTHAN: 'RJ',
  SIKKIM: 'SK',
  TAMILNADU: 'TN',
  TELANGANA: 'TG',
  TRIPURA: 'TR',
  UTTAR_PRADESH: 'UP',
  UTTARAKHAND: 'UK',
  WEST_BENGAL: 'WB',
};
export const stateCodeVsStateNameAndI18N = {
  AN: {stateName: 'ANDAMAN AND NICOBAR ISLAND', I18N: 'ANDAMAN_NICOBAR_ISL'},
  AP: {stateName: 'ANDHRA PRADESH', I18N: 'ANDHRA_PRADESH'},
  AR: {stateName: 'ARUNACHAL PRADESH', I18N: 'ARUNACHAL_PRADESH'},
  AS: {stateName: 'ASSAM', I18N: 'ASSAM'},
  BR: {stateName: 'BIHAR', I18N: 'BIHAR'},
  CH: {stateName: 'CHANDIGARH', I18N: 'CHANDIGARH'},
  CT: {stateName: 'CHHATTISGARH', I18N: 'CHHATTISGARH'},
  DH: {
    stateName: 'DADRA AND NAGAR HAVELI AND DAMAN AND DIU',
    I18N: 'DADRA_HAVELI',
  },
  DL: {stateName: 'DELHI', I18N: 'DELHI'},
  GA: {stateName: 'GOA', I18N: 'GOA'},
  GJ: {stateName: 'GUJARAT', I18N: 'GUJARAT'},
  HR: {stateName: 'HARYANA', I18N: 'HARYANA'},
  HP: {stateName: 'HIMACHAL PRADESH', I18N: 'HIMACHAL_PRADESH'},
  JK: {stateName: 'JAMMU KASHMIR', I18N: 'JAMMU_KASHMIR'},

  JH: {stateName: 'JHARKHAND', I18N: 'JHARKHAND'},
  KA: {stateName: 'KARNATAKA', I18N: 'KARNATAKA'},
  KL: {stateName: 'KERALA', I18N: 'KERALA'},
  LA: {stateName: 'LADAKH', I18N: 'LADAKH'},
  LD: {stateName: 'LAKSHADWEEP', I18N: 'LAKSHADWEEP'},
  MP: {stateName: 'MADHYA PRADESH', I18N: 'MADHYA_PRADESH'},
  MH: {stateName: 'MAHARASHTRA', I18N: 'MAHARASHTRA'},
  MN: {stateName: 'MANIPUR', I18N: 'MANIPUR'},
  ML: {stateName: 'MEGHALAYA', I18N: 'MEGHALAYA'},
  MZ: {stateName: 'MIZORAM', I18N: 'MIZORAM'},
  NL: {stateName: 'NAGALAND', I18N: 'NAGALAND'},
  OR: {stateName: 'ODISHA', I18N: 'ODISHA'},
  PY: {stateName: 'PUDUCHERRY', I18N: 'PUDUCHERRY'},
  PB: {stateName: 'PUNJAB', I18N: 'PUNJAB'},
  RJ: {stateName: 'RAJASTHAN', I18N: 'RAJASTHAN'},
  SK: {stateName: 'SIKKIM', I18N: 'SIKKIM'},
  TN: {stateName: 'TAMILNADU', I18N: 'TAMILNADU'},
  TG: {stateName: 'TELANGANA', I18N: 'TELANGANA'},
  TR: {stateName: 'TRIPURA', I18N: 'TRIPURA'},
  UP: {stateName: 'UTTAR PRADESH', I18N: 'UTTAR_PRADESH'},
  UK: {stateName: 'UTTARAKHAND', I18N: 'UTTARAKHAND'},
  WB: {stateName: 'WEST BENGAL', I18N: 'WEST_BENGAL'},
};

export const getStateCodeStateNameByIndex = (index) => {
  return Object.keys(stateCodeVsStateNameAndI18N).at(index);
};
export const setStateDataInSessionStorageByStateCode = (stateCode) => {
  const stateCodeAndStateName = stateCodeVsStateNameAndI18N[stateCode];
  if (stateCodeAndStateName) {
    const {stateName, I18N} = stateCodeAndStateName;
    sessionStorage.setItem('offer_state', stateName);
    sessionStorage.setItem('i18nName', i18n.t(I18N));
    sessionStorage.setItem('offer_state_code', stateCode);
  }
};

export const setStateDataInSessionStorageByI18NStateName = (i18NStateName) => {
  const stateCode = stateI18NNameVsStateCode[i18NStateName];
  const {stateName, I18N} = stateCodeVsStateNameAndI18N[stateCode];
  sessionStorage.setItem('offer_state_code', stateCode);
  sessionStorage.setItem('offer_state', stateName);
  sessionStorage.setItem('i18nName', I18N);
};
